import { Component, OnInit } from '@angular/core';
import { LanguageService } from '@signature-it/ngx-generic/services';
import { ILanguage } from '@signature-it/ngx-generic/interfaces';

@Component({
    selector: 'langs-sidebar',
    templateUrl: './langs-sidebar.html',
    styleUrls: ['./langs-sidebar.scss'],
    standalone: false
})
export class LangsSidebarComponentGeneric implements OnInit {
    langList: ILanguage[] = [];

    constructor(public langSvc: LanguageService) {
    }

    ngOnInit(): void {
        this.langList = this.langSvc.Langlist;
    }

}
